import React from 'react';
import Search from '../Search/Search';

const Header = ({ toggler, setGender }) => {
    return (
        <div className="filter-section d-flex justify-content-between">
            <Search />
            <div className="radios ">
                <span className="me-2">Filter by: </span>
                <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="" onChange={e => setGender(e.target.value)} />
                    <label className="form-check-label" >All</label>
                </div>
                <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="male" onChange={e => setGender(e.target.value)} />
                    <label className="form-check-label" >Male</label>
                </div>
                <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio3" value="female" onChange={e => setGender(e.target.value)} />
                    <label className="form-check-label" >Female</label>
                </div>
            </div>

            <div className="form-check form-switch">
                <span className="form-check-label" >Tile view</span>
                <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" onClick={toggler} />
            </div>
        </div>
    );
};

export default Header;